<template>
    <div id="headerPage">
      <div class="pcNav" :class="{whiteNav: !isTop}">
        <div class="content-header">
          <div class="nav-tab">
            <img class="logo-img" @click="$router.push('/home')" :src="isTop ? 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/logo.png' : 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/logo-black.png'" alt="logo-img"/>
          </div>
          <div class="nav-list">
              <navItem :isTop="isTop" class="nav-item" :class="{active: (item.path!== '/' && $route.path.indexOf(item.path) >= 0), hasChild: item.children&&item.children.length>0, isPro: index === 1 }" v-for="(item, index) in  navList" :key="index" :vm="item"></navItem>
              <button class="login-btn" @click="doLogin">登录</button>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import navItem from './components/navItem'
import navItemMobile from './components/navItemMobile'
import navButton from '@/components/home/navButton'
import { navList } from '@/const/index'
export default {
  props: {
    isTop: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      navList: navList,
      isShow: false,
      currentType: 0,
      mobileShow: false,
      defaultNav: [{ path: '/application', name: '申请合作' }]
    }
  },
  watch: {
    isMobile (val) {
      if (val) {
        this.mobileShow = true
      }
    }
  },
  components: { navItem, navButton, navItemMobile },
  computed: {
    isPc () {
      return this.$store.state.isPC
    },
    isMobile () {
      return this.$store.getters.isMobile || false
    },
    mobileNavList () {
      return this.navList.concat(this.defaultNav)
    }
  },
  created () {
    console.log(this.$store.getters.isMobile, 'header-mobile')
  },
  methods: {
    select (data) {
      this.isShow = !data.isClose
      if (this.currentType === Number(data.type)) {
        this.currentType = 0
      } else {
        this.currentType = Number(data.type)
      }
    },
    goApplication () {
      this.$router.push('/application')
      //   this.currentIndex = -1
      this.isShow = false
    },
    doLogin () {
      // window.open(`${process.env.VUE_APP_LOGIN_URL + '/auth/login'}`)
      window.open(`https://main.mofaxiao.com/auth/login`)
    },
    showList () {
      this.isShow = true
    },
    closeList () {
      this.isShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
#headerPage{
    .pcNav{
      position: fixed;
      top: 0;
      left: 0;
      right: 0px;
      transition: background-color 1s;
      height: 80px;
      z-index: 1030;
      color: #fff;
      .content-header{
        width: $main-width;
        padding: 0 87px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        .nav-tab{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .logo-img{
              width: 293px;
              height: 31px;
              vertical-align: sub;
              cursor: pointer;
              margin-right: 40px;
          }
        }
        .nav-list{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .active{
              color: #ffffff;
              position: relative;
              ::v-deep .nav-main-item::before{
                content: ' ';
                position: absolute;
                bottom: 26px;
                display: block;
                width:26px;
                height:3px;
                background:#FE5843;
                border-radius:2px;
                left: 50%;
                transform: translateX(-50%);
              }
              &.hasChild{
                ::v-deep .nav-main-item::before{
                  margin-left: -11px;
                }
              }
            }
            .nav-item{
              margin-right: 50px;
              &.isPro{
                width: 97px;
              }
            }
            .login-btn {
              display: none;
              width:96px;
              height:34px;
              border-radius:5px;
              border: 0px;
              color: #ffffff;
              background:rgba(255,255,255,0.35);
              &:hover {
                cursor: pointer;
                color: $base-font-color;
                background-color: #ffffff;
              }
            }
        }
      }
    }
    .whiteNav, .isSuccess{
      background-color: rgba(255, 255, 255, 1) !important;
      transition: background-color 1s;
      color: #333333;
      box-shadow: 0px 6px 5px -5px rgba(116,130,153,0.08);
      .content-header{
        .nav-list{
          .active{
            color: $base-font-color;
          }
          .login-btn {
            display: none;
              width:96px;
              height:34px;
              border-radius:5px;
              border:1px solid rgba(254,88,67,0.35);
              color: #FE5843;
              background: #ffffff;
              &:hover {
                cursor: pointer;
                color: #ffffff;
                background-color: #FE5843;
              }
            }
        }
      }
    }
  .mobileNav{
    display: none
  }
}
</style>
